import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'

const useAppDispatch = () => useDispatch() as AppDispatch

export default useAppDispatch
